import "./Dispatchers.css";
import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../../index";

const LoadingIndicator = () => (
  <div className="loading-indicator">
      <p>Загрузка...</p>
  </div>
);

const EmptyRequestsMessage = () => (
  <div className="empty-requests-message">
      <p>Данные не найдены <img src="./img/document-error.svg" alt="NotFoundData" /></p>
  </div>
);

export function Dispatchers() {
  const [dispatchers, setDispatchers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const usersRef = ref(db, "users");
    onValue(usersRef, (snapshot) => {
      const usersData = snapshot.val();
      const dispatchersList = Object.values(usersData).filter((user) => user.role === "Диспетчер");
      setDispatchers(dispatchersList);
      setLoading(false);
    });
  }, []);

  return (
    <div className="table__dispatcher">
      <h1>Диспетчеры</h1>
      <div className="items-table__list media-dispatcher">
        <span>Email</span>
        <span>Имя</span>
        <span>Телефон</span>
      </div>
      {loading ? (
        <LoadingIndicator />
      ) : dispatchers.length === 0 ? (
        <EmptyRequestsMessage />
      ) : (
        <div>
          {dispatchers.map((dispatcher) => (
            <div className="items-table__list items-table__disp" key={dispatcher.userID}>
              <div className="items-table__disp-holder">
                <p>{dispatcher.email}</p>
              </div>
              <div className="items-table__disp-holder">
                <p>{dispatcher.displayName || "Не указано"}</p>
              </div>
              <div className="items-table__disp-holder">
                <p>{dispatcher.phoneNumber || "Не указан"}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}